export const doRegistration = (mainSite) => {
	let regLink = false;
	const tid = getPARAM('tid');

	let _regLink = getAdvData(regLink);

	if (_regLink !== false) {
		window.location.href = _regLink;
	} else {
		if (tid) {
			shootPixel(() => {
				window.location.href = `${mainSite}?neodl=registration&AR=${readAdvCookie(
					'ar'
				)}&PAR=${readAdvCookie('par')}`;
			});
		} else {
			window.location.href = `${mainSite}?neodl=registration&AR=${readAdvCookie(
				'ar'
			)}&PAR=${readAdvCookie('par')}`;
		}
	}
};

const getAdvData = (regLink) => {
	const queryDict = {};
	let defAr = '';
	let defPar = '';

	new URLSearchParams(window.location.search.substring(1)).forEach(
		(value, key) => {
			queryDict[key.toLowerCase()] = value;
		}
	);

	const ar = queryDict['ar'];
	const par = queryDict['par'];

	if (!!ar) {
		defAr = ar;
	}
	if (!!par) {
		defPar = par;
	}

	if (defAr === '177') {
		regLink = `http://traffic.focuusing.com/process?${window.location.search.substring(1)}&direct=1`;

		if (regLink.includes('&code=')) {
			regLink = regLink.replace('&code=', '&r_code=');
		}
	}

	if (!readAdvCookie('ar')) {
		rewriteAdvCookie('ar', encodeURIComponent(defAr), 60);
	}
	if (!readAdvCookie('par')) {
		rewriteAdvCookie('par', encodeURIComponent(defPar), 60);
	}

	return regLink;
};

const readAdvCookie = (name) => {
	const nameEQ = name + '=';
	const nDecoded = decodeURIComponent(document.cookie);
	const ca = nDecoded.split(';');

	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) == 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
};

const rewriteAdvCookie = (name, value, days) => {
	let expires;

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `;expires=${date.toGMTString()}`;
	} else {
		expires = '';
	}
	const domain = window.location.hostname?.includes('magicred.com') ? window.location.hostname : '.magicred.com';
	// document.cookie = `${name}=${value}${expires};domain=${window.location.hostname};path=/`; // for dev
	document.cookie = `${name}=${value}${expires};domain=${domain};path=/`; // for prod
};

const shootPixel = (callback) => {
	const tid = getPARAM('tid');
	const zone = getPARAM('zone');
	const traffic_source = getPARAM('traffic_source');
	const pixelUrl = `https://record.eshkol.com/_q5h4xISYMFhDp78Ph1_jCGNd7ZgqdRLk/1/?payload=PTM_FallBack_${traffic_source}_${zone}_${tid}`;

	const iframe = document.createElement('iframe');
	iframe.id = 'clickpixel';
	iframe.src = pixelUrl;
	iframe.width = '1px';
	iframe.height = '1px';
	iframe.style.cssText = 'position: absolute; bottom: 0; left: 0;';

	document.body.appendChild(iframe);
	iframe.onload = function () {
		callback();
	};
};

const getPARAM = (name) => {
	const params = new URLSearchParams(window.location.search);
	return params.get(name);
};
